"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-6 w-20 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-foreground/90 hover:text-primary transition-colors relative py-2 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-10 w-full bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <>
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} onClick={onClose} className="text-lg font-medium text-foreground hover:text-primary py-2 border-b border-border/50 transition-colors" data-index={i}>
          {item.label}
        </Link>)}
      <Button asChild variant="outline" className="mt-4 w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent transition-all duration-300" onClick={onClose}>
        <Link to="#contato">Fale Conosco</Link>
      </Button>
    </>;
}
export default function KrbHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="cabeçalho-krb" className={`dark bg-background text-foreground sticky top-0 z-50 transition-all duration-300 ${isScrolled ? "bg-background/90 backdrop-blur-md border-b border-border shadow-sm" : "bg-background border-b border-transparent"}`}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        {}
        <Link to="/HomePage#" className="flex-shrink-0 z-50 relative">
          <img src="https://absolute-tuna.10web.cloud/wp-content/uploads/2026/03/logo-krb.png" alt="KRB Accounting Services Ltd" className="h-7 w-auto object-contain" />
        </Link>

        {}
        <MenuProvider menu_id="16" className="hidden lg:flex flex-1 justify-center">
          <DesktopNav />
        </MenuProvider>

        {}
        <div className="flex items-center gap-4 z-50 relative">
          <Button asChild variant="outline" className="hidden lg:inline-flex border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent transition-all duration-300">
            <Link to="#contato">Fale Conosco</Link>
          </Button>

          <Button variant="ghost" size="icon" onClick={() => setIsMobileOpen(!isMobileOpen)} className="lg:hidden text-foreground hover:text-primary hover:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0" aria-label="Toggle menu">
            {isMobileOpen ? <X className="size-6" /> : <Menu className="size-6" />}
          </Button>
        </div>
      </div>

      {}
      <div className={`lg:hidden absolute top-full left-0 w-full bg-background border-b border-border shadow-lg transition-all duration-300 overflow-hidden ${isMobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="p-4">
          <MenuProvider menu_id="16" className="flex flex-col gap-2">
            <MobileNav onClose={() => setIsMobileOpen(false)} />
          </MenuProvider>
        </div>
      </div>
    </header>;
}